import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-127" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5" data-id="element-128" data-mp="1o3dj01a9xtlv">
        <div className="border border-gold-soft bg-white px-7 py-12 text-center shadow-card sm:px-12" data-id="element-129" data-mp="223y4j57kq3j2">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-tint" data-id="element-130" data-mp="1x42054uysa2z">
            <ShieldCheckIcon className="h-7 w-7 text-gold-dark" aria-hidden="true" data-id="element-131" data-mp="19fsk6jkfmgjr" />
          </span>

          <h2 className="mt-7 font-serif text-3xl sm:text-4xl text-ink" data-id="element-132" data-mp="14gpeqy0ji8b9">
            Garantía de 7 días — sin preguntas
          </h2>
          <div className="rule-gold mx-auto mt-7 w-24" aria-hidden="true" data-id="element-133" data-mp="1j5vdylzdnyj5" />

          <p className="mt-7 font-serif text-xl italic leading-snug text-gold-dark" data-id="element-134" data-mp="1ed27nto9gi4y">
            Descárgalo. Abre los seis tomos. Úsalo con la próxima consulta que te llegue.
          </p>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink-soft" data-id="element-135" data-mp="lo52ms928hu5">
            Si en 7 días no es lo que esperabas, te devolvemos el 100% — sin formularios, sin
            vueltas, sin resentimientos. Ya invertiste en un curso que no te sirvió. Esta vez
            el riesgo es nuestro, no tuyo.
          </p>
        </div>
      </div>
    </section>;
}